import { FILTER_OPTIONS_CACHE_KEYS } from "@nexus/contracts"
import type { DrilldownQuerySection } from "@/lib/queries/drilldown.queries"

const MAX_ENTRIES = 5

/** Module-scoped LRU for CreativeHashData results. */
const lruCache = new Map<string, DrilldownQuerySection>()

export function creativeHashCacheKey(
  hash: string,
  industry: string,
  startDate: string,
  endDate: string,
  dateRange: string,
): string {
  return `${FILTER_OPTIONS_CACHE_KEYS.creativeHash.version}|${hash}|${industry}|${startDate}|${endDate}|${dateRange}`
}

export function peekCachedCreativeHashData(key: string): DrilldownQuerySection | undefined {
  return lruCache.get(key)
}

/** Move a cached entry to the MRU position without reading during render. */
export function touchCachedCreativeHashData(key: string): void {
  const hit = lruCache.get(key)
  if (!hit) return
  lruCache.delete(key)
  lruCache.set(key, hit)
}

export function getCachedCreativeHashData(key: string): DrilldownQuerySection | undefined {
  const hit = peekCachedCreativeHashData(key)
  if (!hit) return undefined
  touchCachedCreativeHashData(key)
  return hit
}

export function setCachedCreativeHashData(key: string, section: DrilldownQuerySection): void {
  if (lruCache.has(key)) {
    lruCache.delete(key)
  }
  lruCache.set(key, section)
  while (lruCache.size > MAX_ENTRIES) {
    const oldest = lruCache.keys().next().value
    if (oldest === undefined) break
    lruCache.delete(oldest)
  }
}

export function clearCreativeHashDataCacheForTests(): void {
  lruCache.clear()
}
